import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=41f201e2&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41f201e2')) {
      api.createRecord('41f201e2', component.options)
    } else {
      api.reload('41f201e2', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=41f201e2&", function () {
      api.rerender('41f201e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Forms/Checkbox.vue"
export default component.exports